(() => {
  const triggers = new WeakMap();
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-neb-support]');
    const dialog = document.getElementById('neb-support-dialog');
    if (!button || !dialog) return;
    triggers.set(dialog, button);
    dialog.showModal();
  });
  const init = () => {
    const dialog = document.getElementById('neb-support-dialog');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    dialog.querySelector('[data-neb-support-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => triggers.get(dialog)?.focus({preventScroll:true}));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
